import React from "react";

export const TokenCell = ({ value }) => (value ? <span className="token">{value}</span> : null);

export const MonoCell = ({ value }) => (value ? <span className="font-monospace">{value}</span> : null);
